import get from 'transmute/get';
export const getMessageById = (messageId, messages) => {
  if (!messages) return null;
  return get(messageId, messages);
};